export default {
  addSample: 'Pridať vzorku',
  createOneTimePart: 'Vytvoriť jednorazový diel',
  sample: {
    defaultDisplayName: 'Vzorka',
  },
  tableTest: {
    defaultDisplayName: 'Tabuľka',
  },
  chartTest: {
    defaultDisplayName: 'Graf',
  },
  imageTest: {
    defaultDisplayName: 'Obrázok',
  },
  fileTest: {
    defaultDisplayName: 'Súbor',
  },
};
